import React from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { 
  ComposedChart, Line, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, ReferenceLine, Label,
} from 'recharts';


import { useState, useEffect} from "react";
import { fetchConToken } from "helpers/fetch";
import { mapSelectedSensorsStr } from "helpers/sensors";
import { useSelector} from 'react-redux';



import PropTypes from 'prop-types';
//import CustomizedAxisTick from './CustomizedAxisTick';
import moment from "moment";
import Swal from 'sweetalert2';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import { MultiSelect } from "components/MultiSelect/MultiSelect";
import CustomButton from "components/CustomButtons/Button"
import PredictionChart from "./PredictionChart";

import "./predictionAreaChart.css"
import classes from './Prediction.module.css';
let modifiedDateData = [];




export default function PredictionAreaChart(props) {
  
  
  const { query, fillcolor, strokecolor, units, factor, listaSensoresHistoricos } = props;


  
  //let predPeriods= 480; //get from state
  
  const [loading, setLoading] = useState(true);
  const [selectedTiempoPred, setSelectedTiempoPred] = useState(480);
  const [selectedSensors, setSelectedSensors] = useState([]);
  
  const [update, setUpdate] = useState(true);
  const [paramsChanged, setParamsChanged] = useState(true);
  
  const [firstTime, setFirstTime] = useState(true);
  const [averageDisplay, setAverageDisplay] = useState('true');

  const handleRadioChange = (event) => {
    setAverageDisplay(event.target.value);
    console.log("selected radio:", event);
    setParamsChanged(true);
    setFirstTime(true);
  };

  const handleChangeTiempoPred = (e) => {
    setSelectedTiempoPred(e.target.value);
    //console.log("selected tiempo:", e); 
    setParamsChanged(true); 
    setFirstTime(true);
  };

  const handleChangeSensors = (e) => {
    setSelectedSensors(e);
    console.log("selected sensors to PAC:", e);
    setParamsChanged(true);
    setFirstTime(true);
    //setSelectedSensorsStr(mapSelectedSensorsStr(e));

    /* dispatch(dataActions.filtrosSensoresHistoricos({
      selectedSensorsMulti: e,
    })) */
      //Array.isArray(e) ? e.map(x => x.value) : []);
  }
  
  const handleApply = (e) => {
    console.log( "apply avdisplay: ", averageDisplay);
    console.log( "sensors lenht: ", selectedSensors.length);
    console.log( "params changed: ", paramsChanged);
    console.log( "update: ", update);

    if (selectedSensors.length > 0){
        setFirstTime(false);
        setUpdate(!update);
        setParamsChanged(false);

        if (paramsChanged){
          setUpdate(!update);
          
          setParamsChanged(false);
        }
    }
    else{
      Swal.fire('Seleccione al menos un sensor', "Debe cambiar su selección", 'warning');
    }
      /* setSelectedSensorsStr(mapSelectedSensorsStr(selectedSensors));

    dispatch(dataActions.filtrosHistoricos({
      selectedMetricasMulti: selectedMetricas,
      selectedSensorsMulti: selectedSensors,
      startDate: selectedDateRange[0],
      endDate: selectedDateRange[1],
    })) */
  }

  let mounted = true;
  


  useEffect(() => {
    
    setSelectedSensors(listaSensoresHistoricos);
    setLoading(false);
    console.log("sensors PAC useEffect:", listaSensoresHistoricos);
    //fetchData();
    return () => mounted = false;
  }, [])
  
  const { language } = useSelector( state => state.data);
  
    const translations = {
      en: {
        forecastTime: "Forecast Time",
        item1d: "1 day",
        item3d: "3 days",
        item5d: "5 days",
        item15d: "15 days",
        sensors: "Sensors:",
        average: "Average (Consolidated)",
        individual: "Individual (Multiple)",
        generate: "Generate Forecast",
      },
      es: {
        forecastTime: "Tiempo de Predicción",
        item1d: "1 dia",
        item3d: "3 dias",
        item5d: "5 dias",
        item15d: "15 dias",
        sensors: "Sensores:",
        average: "Promedio (Consolido)",
        individual: "Individual (Múltiples)",
        generate: "Generar Predicción",
      }
    };
  
    // Get the current translation based on language
    const t = translations[language];


  return (
    
      <div style={{ width: '100%', height: '100%' }}>
        
            <div style={{display:'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap:'wrap'}}>
              <div style={{display: "flex", flexDirection: 'row',  justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
                <div className="filtersTitle"> {t.forecastTime} </div>
                    
                       
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }} size="small">
                          <Select
                            value={selectedTiempoPred}
                            onChange={handleChangeTiempoPred}
                            displayEmpty
                          >
                            <MenuItem value={96}>{t.item1d}</MenuItem>
                            <MenuItem value={288}>{t.item3d}</MenuItem>
                            <MenuItem value={480}>{t.item5d}</MenuItem>
                            <MenuItem value={1440}>{t.item15d}</MenuItem>
                          </Select>
                          
                        </FormControl>
                  
              </div>
                
              <div style={{display: "flex", flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
                <div className="filtersTitle"> {t.sensors} </div>
                <div style={{marginBottom: '1px', marginLeft: '5px', maxWidth:'300px', minWidth:'250px'}}>
                       <MultiSelect options={listaSensoresHistoricos} value={selectedSensors} onChange={handleChangeSensors} />
                    
                </div>
              </div>
              <div style={{display: "flex", flexDirection: 'row',  justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '5px', marginBottom: '1px', flexWrap:'wrap'}}>
                  
                <FormControl>
                  
                  <RadioGroup
                    aria-labelledby="controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={averageDisplay}
                    onChange={handleRadioChange}
                    row
                    //fontSize
                  >
                    <div className="filtersTitle" > {t.average + ' '} &nbsp;
                       <FormControlLabel value={true} control={<Radio size="small"/>} /> 
                    </div>
                    {/* <FormControlLabel value={true} control={<Radio size="small"/>} label="Promedio (Unificado)" labelPlacement="top" />
                    <FormControlLabel value={true} control={<Radio size="small"/>} label="Promedio (Unificado)" labelPlacement="top" /> */}
                    <div className="filtersTitle"> {t.individual} &nbsp;
                       <FormControlLabel value={false} control={<Radio size="small"/>} />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              <div style={{display: "flex", justifyContent: 'flex-start', alignItems: 'flex-end', padding: '1px', marginLeft: '5px', marginBottom: '1px'}}>
                
                  <CustomButton color="green" round={true} size='sm' onClick={handleApply} disabled={(paramsChanged)?false:true} > 
                    {t.generate} 
                  </CustomButton>
                
              </div>
            </div>
            
        
                
        
        {(loading) && (
                   <div className={classes.loading} style={{display: "flex", justifyContent: 'center', alignItems: 'flex-start'}}>
                       <LoadingSpinner />
                   </div>)
        }
        
  


        {(()=>{    
          let rows = [];
                  /* console.log("firstTime:",firstTime);
                  console.log("avDisplay:",averageDisplay);
                  console.log("selec sensors lenght inside if:",selectedSensors.length); */
          if (!firstTime) {
            
            if (averageDisplay==='true' && selectedSensors.length > 1) {
                  //console.log("entered disply average:");
                  rows = [];
                  rows.push(<PredictionChart key={'key'+selectedSensors.length} query={query} fillcolor={fillcolor} strokecolor={strokecolor} units={units} factor={factor} selectedSensors={selectedSensors} selectedTiempoPred={selectedTiempoPred} update={update} />);
                  
            }else{
              if (averageDisplay==='false' && selectedSensors.length > 1){
                
                rows = [];
                for (let i = 0; i < selectedSensors.length; i++) {
                  //console.log("sensor in PAC IND:",selectedSensors[i].label);
                  rows.push(
                    <div style={{minHeight: '200px'}} key={selectedSensors[i].label}>
                    <div className="filtersTitle"> {selectedSensors[i].label} </div>
                    <PredictionChart key={"pc"+i+Math.random()} query={query} fillcolor={fillcolor} strokecolor={strokecolor} units={units} factor={factor} selectedSensors={selectedSensors.slice(i, i+1)} selectedTiempoPred={selectedTiempoPred} update={update} />
                    </div>
                  )
                  
            
                }
              }else {
                if (selectedSensors.length == 1){
                  rows = [];
                  rows.push(<PredictionChart key={'key'+selectedSensors.length} query={query} fillcolor={fillcolor} strokecolor={strokecolor} units={units} factor={factor} selectedSensors={selectedSensors} selectedTiempoPred={selectedTiempoPred} update={update} />);
                }
              }
            }
            
          }  
          return rows;    
  
        })()}

      </div>
    
  );

};





